import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import CONST from '@/utils/const'
import { getOpenId } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BACKEND_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60 * 1000, // request timeout
  headers: {
    'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded',   // 表单提交
  },
  responseType: 'json'
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.data = config.data || {}
    config.data.append('open_id' , getOpenId())
    config.data.append('cx_user' , CONST.CX_USER)
    return config
  },
  error => {
    // do something with request error
    console.error('request: ', error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (!res.success) {
      Vue.prototype.error(res.msg)
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.error('response: ', error) // for debug
    Vue.prototype.error(error)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/upload-request.js